import React from "react";
import styles from "./CampaignEmptyState.module.scss";
import { Button, ButtonSize, PlusSquare } from "@bale/ui";
import { useTheme } from "@emotion/react";
import { strings } from "intl/fa";

type Props = {
  onButtonClick: VoidFunction;
};

const CampaignEmptyState = (props: Props) => {
  const theme = useTheme();
  return (
    <div className={styles.Container}>
      <img src="/icons/megaphone.svg" alt="" />
      <p className={styles.Title}>اولین کمپین خود را بسازید.</p>
      <Button
        size={ButtonSize.Medium}
        icon={
          <PlusSquare
            size={20}
            color={theme.colors.light[0]}
            style={{ marginLeft: "4px" }}
          />
        }
        className={styles.AddButton}
        onClick={props.onButtonClick}
        style={{ marginTop: "8px" }}
      >
        {strings.ad_sale.create_campaign}
      </Button>
    </div>
  );
};

export default CampaignEmptyState;
